import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, DATETIME, INTEGER, STRING, UUID, ITEM } from '@/plugins/sdk/fields'
import Account from '@/plugins/sdk/resources/Account'

export default class extends Resource {
  static name = 'account_location'

  static get fields () {
    return {
      id: new UUID(),
      name: new STRING(),
      address_1: new STRING(),
      address_2: new STRING(),
      suburb: new STRING(),
      state: new STRING(),
      postcode: new INTEGER(),
      country: new STRING(),
      contact: new STRING(),
      phone: new STRING(),
      fax: new STRING(),
      email: new STRING(),
      notes: new STRING(),
      branch3p: new BOOLEAN(),
      residential: new BOOLEAN(),
      instructions: new STRING(),
      deleted: new BOOLEAN(),
      deleted_date: new DATETIME(),
      account: new ITEM(Account),
      is_default_address: new BOOLEAN()
    }
  }

  static get sortables () {
    return [
      { field: 'name', label: 'Name' },
      { field: 'address_1', label: 'Address 1' },
      { field: 'address_2', label: 'Address 2' },
      { field: 'suburb', label: 'Suburb' },
      { field: 'state', label: 'State' },
      { field: 'postcode', label: 'Postcode' },
      { field: 'country', label: 'Country' },
      { field: 'contact', label: 'Contact' },
      { field: 'phone', label: 'Phone' },
      { field: 'fax', label: 'Fax' },
      { field: 'email', label: 'Email' },
      { field: 'residential', label: 'Residential' },
      { field: 'created_at', label: 'Created Date' },
      { field: 'updated_at', label: 'Updated Date' },
      { field: 'account.account_name', label: 'Account Name' }
    ]
  }
}
